export const ADMIN_OPERATION_SPECIAL_TRANSLATION_NAMESPACE = "operation-special";

export const ADMIN_OPERATION_SPECIAL_TK = "ADMIN_OPERATION_SPECIAL_TK";
